import React, {useEffect, useState} from "react";
import {Tabs} from "components/common";
import "./Sample.scss";
// import {items} from "./config";
import {useAppDispatch} from "redux/hooks";

import type {TabsProps} from "antd";
import Parent from "./tabs/PassData/Parent";
import HandleForm from "./tabs/HandleForm/HandleForm";
import Ref from "./tabs/Ref/Parent";
import CallApi from "./tabs/CallApi/CallApi";
import TableFormList from "./tabs/SetHeader/TableFormList/TableFormList";
import SetHeader from "./tabs/SetHeader/SetHeader";
import {tabKeys} from "types/enums";
import Modal from "./tabs/Modal/Modal";

const items: TabsProps["items"] = [
  {
    key: tabKeys.SAMPLE.PASS_DATA,
    label: `Truyền data cha <-> con`,
    children: <Parent />,
  },
  {
    key: tabKeys.SAMPLE.HANDLE_FORM,
    label: `Xử lý form`,
    children: <HandleForm></HandleForm>,
  },
  {
    key: tabKeys.SAMPLE.REF,
    label: `Ref`,
    children: <Ref></Ref>,
  },
  {
    key: tabKeys.SAMPLE.CALL_API,
    label: `Call Api`,
    children: <CallApi></CallApi>,
  },
  {
    key: tabKeys.SAMPLE.TABLE_FORMLIST,
    label: `Table Form List`,
    children: <TableFormList></TableFormList>,
  },
  {
    key: tabKeys.SAMPLE.SET_HEADER,
    label: `Button trên header`,
    children: <SetHeader></SetHeader>,
  },
  {
    key: tabKeys.SAMPLE.MODAL,
    label: `Modal`,
    children: <Modal></Modal>,
  },
];

const Sample: React.FC = () => {
  useEffect(() => {}, []);

  return (
    <div className="sample page">
      <div className="main ">
        {/* <Tabs items={items} /> */}
        <HandleForm></HandleForm>
      </div>
    </div>
  );
};
export default Sample;
